<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 title">
              <h4 class="page-heading">Water-Related Sustainable Development Goals</h4>
              <h2 class="intro-text" i18n>DRR/Resilience - Resources</h2>
            </div>
            <div class="col-sm-6">
              <a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px; background: #1f487c;">
                <span i18n>Resources</span>
              </a>
              <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Questionnaire</span>
              </a>
              <a (click) = "dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Data</span>
              </a>
              <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Reporting</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<section class="content-section">
    <mat-table #table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="column1">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Tool/Resource </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column1}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column2">
              <mat-header-cell *matHeaderCellDef> Link to tool/resource </mat-header-cell>
              <mat-cell *matCellDef="let element"> <a href= {{element.column2}}>Link</a> </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column3">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data source  </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column3}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column4">
              <mat-header-cell *matHeaderCellDef> Link to data source </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column4}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column5">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Indicator number in tool/resource </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column5}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column6">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Used in SDG-PSS </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column6}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column7">
              <mat-header-cell *matHeaderCellDef> Indicator title </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column7}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column8">
              <mat-header-cell *matHeaderCellDef> Measure/Question/Sub-indicator</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column8}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
  <!-- <table class="table table-striped resources-table" >
    <thead>
      <tr class="row-name ">
        <th class="text-center">Theme/Source</th>
        <th class="text-center">Link to Tool and recomended indicator</th>
        <th class="text-center">International data sources</th>
        <th class="text-center">Link to international level<br> data used in 2017</th>
        <th class="text-center">Indicator number</th>
        <th class="text-center">Used in generic PSS?</th>
        <th class="text-center">Suggested Target</th>
        <th class="text-center">Measure/Question/Sub-indicator</th>
      </tr>
    </thead>
    <tbody class="text-center">
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>A1</td>
        <td>No</td>
        <td>Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015</td>
        <td>Number of [deaths/Deceased] and [missing[persons] / presumed dead] due to hazardous events per 100,000<br>Alt) Number of deaths, missing, injured, displaced or [evacuated] due to hazardous events per 100,00</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>A2</td>
        <td>No</td>
        <td>Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015</td>
        <td>Number of [deaths/deceased] due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>A3</td>
        <td>No</td>
        <td>Substantially reduce global disaster mortality by 2030, aiming to lower average per 100,000 globally mortality between 2020-2030 compared to 2005-2015</td>
        <td>Number of [missing [persons] / presumed dead] due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B1</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of affected people [by hazardous event / due to hazardous events] per 100,00</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B2</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of injured or ill people due to hazardous events.<br>Alt) Number of people suffering from physical injuries, trauma or cases of disease requiring immediate medical assistance as a direct result of a hazardous event.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B3</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of people who left their [places of residence / home][and places where they are] due to hazardous events.<br>Alt) Number of people displaced due to hazardous events<br>Alt-bis) Number of people evacuated, relocated and displaced due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B4</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of people whose [houses / dwellings or homes] were damaged due to hazardous events.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B5</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of people whose [houses / dwellings or homes] were destroyed due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B6</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of people who [received / required] [food relief aid / aid including food [and non-food] and medical aid] [among other things] due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>B7</td>
        <td>No</td>
        <td>Substantially reduce the number of affected people globally by 2030, aiming to lower the average global figure per 1000,000 between 2020-2030 compared to 2005-2015</td>
        <td>Number of people whose livelihoods were disrupted, destroyed or lost due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C1</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2030</td>
        <td>Direct economic loss due to hazardous events [in relation to global gross domestic product</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C2</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2031</td>
        <td>Direct agricultural loss due to hazardous events.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C3</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2032</td>
        <td>Direct economic loss due to industrial facilities damaged or destroyed by hazardous events.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C4</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2033</td>
        <td>Direct economic loss due to commercial facilities [and services] damaged or destroyed by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C5</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2034</td>
        <td>Direct economic loss due to houses damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C6</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2035</td>
        <td>Direct economic loss due to houses destroyed by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C7</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2036</td>
        <td>Direct economic loss due to damage to [critical infrastructure / public infrastructure] caused by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C8</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2037</td>
        <td>Direct economic loss due to cultural heritage damaged or destroyed by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C9</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2038</td>
        <td>Direct economic loss due to environment degraded by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C10</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2039</td>
        <td>Financial transfer and access to insurance</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C11</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2040</td>
        <td>Direct economic losses due to disruptions to basic services</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>C12</td>
        <td>No</td>
        <td>Reduce direct disaster economic loss in relation to global gross domestic product (GDP) by 2041</td>
        <td>Direct economic loss due to services sectors (such as transportation, tourism, finance) caused by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D1</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2030</td>
        <td>Damage to critical infrastructure due to hazardous events  bis) Number of electricity plants and transmission towers destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D2</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2031</td>
        <td>[Number / percentage] of health facilities [including mental health services.] destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D3</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2032</td>
        <td>[Number / percentage] of educational facilities destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D4</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2033</td>
        <td>[Number / percentage] of [major] transportation [units and] infrastructures destroyed or damaged by hazardous events.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D5</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2034</td>
        <td>[Number / Length / Percentage] of [time / days / person days] basic services have been disrupted due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D6</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2035</td>
        <td>[Number / Percentage] of education or health facilities [removed from risk areas / retrofitted</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D7</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2036</td>
        <td>[Number / percentage] of security service structures destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D8</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2037</td>
        <td>[Number / percentage] of tourist infrastructure facilities destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D9</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2038</td>
        <td>Number of states with resilience programmes or strategies for health and education facilities</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D10</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2039</td>
        <td>Number of communication infrastructure destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D11</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2040</td>
        <td>Percentage of education facilities developed under the safe school program</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D12</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2041</td>
        <td>Percentage of health facilities developed under the safe hospital program</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D13</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2042</td>
        <td>Number of agricultural facilities destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D14</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2043</td>
        <td>Number of water and sanitation infrastructures destroyed or damaged by hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>D15</td>
        <td>No</td>
        <td>Substantially reduce disaster damage to critical <br>infrastructure and disruption of basic services, among them health and educational facilities, including through developing their resilience by 2044</td>
        <td>Number of days financial services have been disrupted due to hazardous events</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E1</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2020</td>
        <td>Number countries that adopt and implement national DRR strategies in line with Sendai for DRR 2015-2030<br><br>Alt) Number of countries with national DRR strategies for implementation of Sendai Framework</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E2</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2021</td>
        <td>Percentage of local governments that adopt and implement local DRR strategies in line with Sendai / national disaster risk strategy<br><br>Alt)  Number of countries and local governmental that adopt and implement local and sector specific DRR strategies in line with Sendai<br>Alt-bis) Percentage of local governments with DRR strategy for implementation of national strategy for Sendai<br></td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E3</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2022</td>
        <td>Number of countries that integrate climate change / adaption into development planning (or have)<br><br>Alt) Number of countries that have integrated DRR and climate change into their national development plan</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E4</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2023</td>
        <td>Number of countries that adopt and implement critical infrastructure protection plan<br><br>bis) Number of countries with resilience programmes or strategies for health and education facilities in the framework of the DRR plans<br>ter) Number of sector/hazard specific DRR strategy/plan development in a country</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E5</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2024</td>
        <td>Number of countries with cross-sectoral bodies/forums, with clear roles and responsibilities identified across state institutions, civil society, private sector and international actors , in the implementation and review of DRR measures<br><br>Alt) Number of countries that adopt and implement specific DRR strategies in line with the Sendai Framework, including cross-sectoral bodies/forums with identified roles and responsibilities, as appropriate, for relevant actors</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E6</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2025</td>
        <td>Number of countries accounting for future risk in public and private balance sheets, setting financial targets to inform investment strategies for reducing risk and enhancing future prosperity </td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E7</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2026</td>
        <td>Number of countries and local governments conducting (independent) periodic outcome reviews of the implementation of national and local DRR strategies</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E8</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2027</td>
        <td>Number of countries that adopt and implement sector specific DRRR strategies in line with the Sendai framework</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E9</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2028</td>
        <td>Number of countries that have national financing mechanisms for DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E10</td>
        <td>Yes</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2029</td>
        <td>Number of countries that have spatial and land use planning mechanisms for DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E11</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2030</td>
        <td>Number of countries that mainstream DRR into national development planning)</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E12</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2031</td>
        <td>Number of people protected by evacuation, improved infrastructure and other relevant measures that reduce the possible impact of disasters on people</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E13</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2032</td>
        <td>Number of people who received/require relief aid or assistance due to a hazardous event</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>E14</td>
        <td>No</td>
        <td>Substantially increase the number of countries with <br>national and local disaster risk reduction strategies by 2033</td>
        <td>Number of people who received/require relief aid or assistance due to a hazardous event</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F1</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2030</td>
        <td>Percentage of gross national product that represents the non-earmarked  adequate  support provided by developed countries and reported by developing countries<br>Alt) percentage of earmarked ODA provided by developed countries and reported by developing countries</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F2</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2031</td>
        <td>Number of developed countries having a policy marker as part of legislation on provisions for support to developing countries to enhance the implementation of the Sendai framework and the fulfilment of global goals</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F3</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2032</td>
        <td>Progress on the implementation of paragraph 47 of the Sendai framework, in particular subparagraphs 47(a) and 47(b)</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F4</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2033</td>
        <td>Progress in using the regional platforms for  exchange of best practices, technology and capacity building in  enhancing south-south cooperation for the implementation of Sendai</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F5</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2034</td>
        <td>F-5) Number of projects and programmes funded  by international organizations in line with paragraph 48 of Sendai</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F6</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2035</td>
        <td>Net ODA for disaster risk reduction, (total and to LDC) as a percentage of total ODA</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F7</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2036</td>
        <td>Number of countries supported in implementing national DRR strategies by aligned programmes of entities of the UN System<br><br>Alt) Amount of resources given to support developing countries implementation of national DRR strategies by programmes of entities of the UN system and other relevant stakeholders</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F8</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2037</td>
        <td>Number of international (multilateral/bilateral) financial institutions that systematically integrate climate change adaption and disaster risk reduction into the design, implementation and evaluation of Official Development Finance / urban planning etc.</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F9</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2038</td>
        <td>Number of countries with international and regional initiatives for the exchange of science, technology and innovation in disaster risk reduction<br><br>Alt) Number of developed countries supporting developing countries' regional initiatives for the exchange of science, knowledge, technology and innovation in DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F10</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2039</td>
        <td>Total amount of funding within ODA to promote the development, transfer, dissemination and diffusion of DRR-related science, technology and innovation (STI)</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F11</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2040</td>
        <td>Number of international and regional multi-stakeholder partnerships established to build individual, institutional and societal capacity for DRRR / DRR capacity in developing countries and the economic value of such partnerships<br><br>Alt)  Number of countries that have regional cooperation to support DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F12</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2041</td>
        <td>Number of countries having participated in a voluntary and mutual review of progress in implementing respective national DRR strategies</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F13</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2042</td>
        <td>Financial and other resources made available to strengthen the statistical capacity of developing countries in collection, analysis and management and use of DRR info</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F14</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2043</td>
        <td>Number of voluntary commitments by international and regional organisations / initiatives related to DRR capacity building of developing countries</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F15</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2044</td>
        <td>Annual percentage of cooperation financing for DRR provided by developed countries and received by developing countries compared with the economic loses registered in developing countries</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F16</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2045</td>
        <td>Total amount of funds provided by developed countries to developing countries to promote development and transfer of ecologically adequate, appropriate and modern technology for DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F17</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2046</td>
        <td>Proportion of cooperation funds for DRR provided by developing countries and registered in the annual budgets of developing countries</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F18</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2047</td>
        <td>Estimated proportion of cooperation for DRR covered by indicative expenditure and/or implementation plans from developed countries for 1,2,3 years in advance</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F19</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2048</td>
        <td>Financial or other resources provided for capacity building to developing countries to strengthen the implementation of their national strategies for DRR</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>F20</td>
        <td>No</td>
        <td>Substantially enhance international cooperation to developing countries through adequate and sustainable support to complement their national actions for implementation of this framework by 2049</td>
        <td>Number of developing/developed countries fostering an enabling environment domestically, to reduce the barriers for technology transfer to developing countries, including through the implementation of national DRR strategies and enhanced mobilization of domestic resources</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G1</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2030</td>
        <td>Number of countries that have coordinated  multi-hazard early warning system</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G2</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2031</td>
        <td>Number of countries that be coordinated  multi-hazard monitoring and forecasting system</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G3</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2032</td>
        <td>Number/percentage of people who are covered by and have access to  multi-hazard early warning systems (per 100,000) </td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G4</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2033</td>
        <td>Percentage/number of local and national  governments having preparedness plan (including EWS response and evacuation components) or evacuation plan tested on regular basis and standard operating procedures</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G5</td>
        <td>Yes</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2034</td>
        <td>Number/percentage of countries that have multi-hazard national risk assessment / risk information with results in an accessible understandable and useable format for stakeholders and people<br><br>Alt) Multi-hazard risk information system capable of providing information in a simple and usable format to common people</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G6</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2035</td>
        <td>Percentage/number of local governments that have multi-hazard risk assessment/risk information, with results in an accessible understandable and usable format for stakeholders and people</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G7</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2036</td>
        <td>Percentage of population with understanding of the risk they are exposed to<br><br>Alt) Number of countries with programmes for the DR perception and understanding of the population</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G8</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2037</td>
        <td>Number of countries that have national plans with budget and timeline for development of multi-hazard EWS</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G9</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2038</td>
        <td>Number of countries that have disaster loss databases publicly accessible</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G10</td>
        <td>Yes</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2039</td>
        <td>Number of countries that have open data policies and mechanisms to make hazard and risk data accessible and available to all users</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G11</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2040</td>
        <td>How many countries provide basic weather, environmental and climate services, as defined by the World meteorological Organization</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G12</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2041</td>
        <td>Percentage of people in local communities able to use indigenous knowledge of the risk they are exposed to</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G13</td>
        <td>No</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2042</td>
        <td>Percentage of local communities trained in community based multi-hazard early warning management system and response</td>
      </tr>
      <tr>
        <td>Sendai Framework for Disaster Risk Reduction</td>
        <td>www.preventionweb.net/drr-framework/sendai-framework/</td>
        <td>None found</td>
        <td>None</td>
        <td>G14</td>
        <td>Yes</td>
        <td>Substantially increase the availability of and access to multi-hazard early warning systems and disaster risk information and assessments to people by 2043</td>
        <td>Number of programmes to enhance awareness, disaster risk information and risk assessment</td>
      </tr>
    </tbody>
  </table> -->
</section>



// WEBPACK FOOTER //
// ./src/app/sdg/resilience/resilience.component.html